const SEO = [
	{
		page: "home",
		description:
			"PhD student in Mechanical Engineering at UT Austin, researching robotic hand design and manipulation.",
		keywords: ["Aaron Kim", "Aaron Jinsoo Kim", "UT Austin robotics"],
	},

	{
		page: "projects",
		description:
			"Research and project portfolio in robotic hand design, manipulation, and mechatronics.",
		keywords: ["Aaron Kim", "Aaron Jinsoo Kim", "UT Austin robotics"],
	},

	// contact page removed
];

export default SEO;
